module.exports = __webpack_public_path__ + "img/five1Red.5f7bf0e8.jpg";